













































import Vue from 'vue';
import UserChangePasswordRequestViewModel from '../../../services/v1/viewModel/resource/UserChangePasswordRequestViewModel';

export default Vue.extend({
  auth: false,
  layout: ['layout-exterior', '_exterior'],
  data: () => ({
    resetPasswordValidationMessage: (undefined as unknown as string),
    isLoading: false,
    requestError: undefined,
    resetPassword: new UserChangePasswordRequestViewModel(),
  }),
  computed: {
    token() {
      return this.$route?.query?.token;
    },
  },
  mounted() {
    this.$set(this.resetPassword, 'token', this.token);
  },
  methods: {
    async resetForgottenPassword() {
      if (!this.resetPassword.validate()) {
        return;
      }
      this.isLoading = true;
      try {
        const { email } = Vue.$router.currentRoute.params;
        await this.$service.api.core.users.changePassword(this.resetPassword);
        await this.$auth.login({ username: email, password: this.resetPassword.newPassword });

        if (this.$auth.isInRole('hostadmin', 'admin')) {
          Vue.$router.replace('/_admin/');
        } else {
          Vue.$router.replace('/');
        }
      } catch (error: any) {
        this.requestError = error;
      }
      this.isLoading = false;
    },
  },
});

